import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { types as facebookActionTypes } from 'actions/facebookActions/facebookActions';

export const initialState = Immutable.fromJS({
  facebookLoginStatus: {},
});

export default handleActions({
  [facebookActionTypes.FACEBOOK_INITIALISE]: (state) =>
    state.merge({ fbInitialised: true }),
  [facebookActionTypes.UPDATE_FACEBOOK_LOGIN_STATUS]: (state, action) =>
    state.merge({ facebookLoginStatus: action.facebookLoginStatus }),
}, initialState);



// WEBPACK FOOTER //
// ./reducers/facebookReducers/facebookReducers.js